import * as React from "react";
import * as ReactDOM from "react-dom";
import classnames from "classnames";
import * as styles from "./styles.scss";
import { Html } from "../../../../components";

interface IRadioProps {
  value: any;
}

const renderRadio = (props: any, i: any) => (
  <div className={styles.option} key={i}>
    <div className={styles.radio}>
      <input type="radio" disabled checked={props.isChecked} />
    </div>
    <pre className={styles.pre}>
      <Html>{props.option}</Html>
    </pre>
  </div>
);

export const Radio = ({ value }: IRadioProps) => (
  <div>{value.map(renderRadio)}</div>
);
